// ##############################
// // // App styles
// #############################
import merge from 'lodash/merge';
import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid
} from "../../material-dashboard-pro-react.jsx";

import {
  positionValues,
  floatDirection,
  clearValues
} from "../stylesConstants.jsx";

function appStyle(theme) {
  let styles =
    {
      wrapper: {
        top: 0,
        height: '100vh',
        "&:after": {
          display: "table"
        }
      },
      map: {
        marginTop: "70px"
      },
      mainPanel: {
        transitionProperty: "top, bottom, width",
        transitionDuration: ".2s, .2s, .35s",
        transitionTimingFunction: "linear, linear, ease",


        [theme.breakpoints.up("md")]: {
          width: `calc(100% - ${drawerWidth}px)`
        },
        overflow: "auto",
        maxHeight: "100%",
        width: "100%",
        overflowScrolling: "touch"
      },
      content: {
        marginTop: "70px",
        padding: "30px 15px",
        minHeight: "calc(100vh - 123px)"
      },
      container: {},
      mainPanelSidebarMini: {
        [theme.breakpoints.up("md")]: {
          width: `calc(100% - ${drawerMiniWidth}px)`
        }
      },
      mainPanelWithPerfectScrollbar: {
        overflow: "hidden !important"
      }
    }
    
    styles.wrapper.position = positionValues.relative;
    styles.wrapper["&:after"].clear = clearValues.both;
    styles.wrapper["&:after"].content =  '""';
    styles.mainPanel.position = positionValues.relative;
    styles.mainPanel.float = floatDirection.right;
    merge(styles.mainPanel, transition);
    merge(styles.container, containerFluid);

    return styles;
}

export default appStyle;
